// src/hooks/useFileUpload.js
import { useState } from 'react';
import { uploadService } from '../service/dataUploadService.mjs';


export const useFileUpload = () => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadMessage, setUploadMessage] = useState('');

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      setUploadError(null);
      setUploadSuccess(false);
      setUploadMessage('');
    }
  };

  const handleFileClear = () => {
    setFile(null);
    setFileName('');
    setUploadError(null);
    setUploadSuccess(false);
    setUploadMessage('');
  };

  const uploadMieBreakdown = async () => {
    if (!file) {
      setUploadError('Please select a file first');
      return;
    }

    setIsLoading(true);
    setUploadError(null);
    
    try {
      const response = await uploadService.uploadMieBreakdown(file);
      setUploadSuccess(true);
      setUploadMessage(response.message || 'MIE breakdown data uploaded successfully');
      setFile(null);
      setFileName('');
    } catch (error) {
      setUploadError(error.message || 'Failed to upload MIE breakdown data');
      setUploadSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  const uploadPerDiemCountry = async () => {
    if (!file) {
      setUploadError('Please select a file first');
      return;
    }

    setIsLoading(true);
    setUploadError(null);
    
    try {
      const response = await uploadService.uploadPerDiemCountry(file);
      setUploadSuccess(true);
      setUploadMessage(response.message || 'Per diem country data uploaded successfully');
      setFile(null);
      setFileName('');
    } catch (error) {
      setUploadError(error.message || 'Failed to upload per diem country data');
      setUploadSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    file,
    fileName,
    isLoading,
    uploadError,
    uploadSuccess,
    uploadMessage,
    handleFileChange,
    handleFileClear,
    uploadMieBreakdown,
    uploadPerDiemCountry
  };
};

